import { PERMISSIONS } from 'containers/Permissions/constants';
import usePermissions from 'containers/Permissions/usePermissions';

const useCustomerPermissions = () => {
  const loyaltyPermissions = usePermissions(PERMISSIONS.CUSTOMER_MANAGEMENT_LOYALTY);
  const gamePermissions = usePermissions(PERMISSIONS.CUSTOMER_MANAGEMENT_GAME);
  const stampsPermissions = usePermissions(PERMISSIONS.CUSTOMER_MANAGEMENT_STAMP);
  const rewardsPermissions = usePermissions(PERMISSIONS.CUSTOMER_MANAGEMENT_REWARD);
  const customerPermissions = usePermissions(PERMISSIONS.CUSTOMER_MANAGEMENT);
  const cashbackPermissions = usePermissions(PERMISSIONS.CUSTOMER_MANAGEMENT_CASHBACK);
  const progressPointsPermissions = usePermissions(PERMISSIONS.CUSTOMER_MANAGEMENT_PROGRESS_POINTS);
  const questTasksPermissions = usePermissions(PERMISSIONS.CUSTOMER_MANAGEMENT_QUEST_TASKS);
  const instantRewardsPermissions = usePermissions(PERMISSIONS.CUSTOMER_MANAGEMENT_INSTANT_REWARDS);
  const raffleTicketsPermissions = usePermissions(PERMISSIONS.CUSTOMER_MANAGEMENT_RAFFLE_TICKETS);
  return {
    loyalty: loyaltyPermissions,
    game_tries: gamePermissions,
    stamps: stampsPermissions,
    rewards: rewardsPermissions,
    user_accounts: customerPermissions,
    cashback: cashbackPermissions,
    progress_points: progressPointsPermissions,
    quest_tasks: questTasksPermissions,
    instant_rewards: instantRewardsPermissions,
    raffle_tickets: raffleTicketsPermissions
  };
};

export default useCustomerPermissions;
